import { Store } from "vuex/types/index"

import { RootState } from "../store.types"

export function loginOnUnauthorized (store: Store<RootState>) {
  let isRedirecting = false
  store.subscribe(mutation => {
    const hasStatusCode = mutation.type && mutation.type.includes('statusCode')
    if (!isRedirecting && hasStatusCode && mutation.payload === 401) {
      // Prevent multiple redirects
      isRedirecting = true
      store.$login(store.$router.currentRoute.fullPath)
    }
  })
}
